import type { ICreateAppointment } from '@/type/Appointment'
import { createSubmitNote, type AppointmentForm } from './useAppointmentForm'

export interface AppointmentPayloadInput {
  form: Pick<AppointmentForm, 'name' | 'mobile' | 'email' | 'branch' | 'doctor' | 'date' | 'note'>
  time: ICreateAppointment['time']
  // id ของบริการที่เลือก (selectedDepositTypeId) - ฟอร์ม validate ว่าเลือกแล้วก่อนสร้างนัด
  depositTypeId: number | null
  // ชื่อสำหรับ note จาก getSelectedDepositTypeNames (ชื่อไทย) - ไม่สร้างชื่อเองที่นี่ ให้ note ของ ABC / Xpress ตรงกัน
  depositTypeNames: string[]
  interestTagNames: string[]
  interestTagIds: number[]
  // เลื่อนนัดผ่านฟอร์มเดียวกัน (Xpress) - ABC เลื่อนนัดที่หน้าอื่น ไม่ต้องส่ง
  isPostpone?: boolean
}

/**
 * Build the appointment payload for the ABC (incl. walk-in) and Xpress appointment pages
 * ใช้ตัวเดียวกันทั้ง 2 หน้า ให้ payload / รูปแบบ note ตรงกัน (ABC เคยสร้าง payload ในหน้าเอง)
 *
 * Postpone sends the note as typed, no deposit_type and empty interest_tags (same as views/public/AppointmentPostpone.vue):
 * backend ignores them on postpone and appends the appointment's original services/procedures to the note itself,
 * so sending a note from createSubmitNote would duplicate that text
 *
 * สร้างนัดส่ง id ของบริการ (LMP-7840) ส่วน note ยังต่อท้ายด้วยชื่อบริการ
 */
export function buildAppointmentPayload({
  form,
  time,
  depositTypeId,
  depositTypeNames,
  interestTagNames,
  interestTagIds,
  isPostpone = false,
}: AppointmentPayloadInput): ICreateAppointment {
  const payload = {
    name: form.name,
    mobile: form.mobile,
    email: form.email,
    branch: form.branch,
    doctor: form.doctor,
    date: form.date,
    time,
  }

  if (isPostpone) {
    return { ...payload, note: form.note, interest_tags: [] }
  }

  return {
    ...payload,
    note: createSubmitNote(form.note, depositTypeNames, interestTagNames),
    deposit_type: depositTypeId,
    interest_tags: interestTagIds,
  }
}
